// Get Link Meta
export const GET_LINK_META_REQUEST = 'GET_LINK_META_REQUEST';
export const GET_LINK_META_DONE = 'GET_LINK_META_DONE';
export const GET_LINK_META_FAILED = 'GET_LINK_META_FAILED';
export const GET_LINK_META_RESET = 'GET_LINK_META_RESET';